'use memo';

import { createFileRoute } from '@tanstack/react-router';
import { AccessRuleEditPage, IDP_AUTH_POLICY_PATHS } from '@/features/authentication-policy';
export const Route = createFileRoute('/_staff/idp/_layout/access-rules/$id/')({
  component: AccessRuleEditRoute
});
function AccessRuleEditRoute() {
  const {
    id
  } = Route.useParams();
  return <AccessRuleEditPage paths={IDP_AUTH_POLICY_PATHS} id={id} />;
}